// src/routing/ProtectedRoute.js
import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from 'context/AuthContext';
import AuthLoader from 'components/AuthLoader';

export default function ProtectedRoute() {
  const { isAuthenticated, loading } = useContext(AuthContext);
  const location = useLocation();

  // Mientras se verifica el token, mostramos el loader en vez de decidir la
  // ruta (evita el parpadeo /ruta -> /login -> /ruta).
  if (loading) return <AuthLoader />;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
